import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useQueryParams } from 'src/hooks';

export const usePageQueryParams = (pathname: string) => {
  const history = useHistory();
  const queryParams = useQueryParams();
  const page = queryParams.get('page') ?? '1';

  const setPage = useCallback(
    (page: number) => {
      queryParams.set('page', `${page}`);
      history.push({ pathname, search: queryParams.toString() });
    },
    [history, pathname, queryParams],
  );

  const resetParams = () => {
    return history.push(pathname);
  };

  return { page: Number(page), setPage, resetParams };
};
